// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { isValid, submit } from 'redux-form';

import { bindActionCreatorsForm } from 'util/safeDispatch';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import localizedStrings from 'util/localizedStrings';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';

import { getActivePanelId } from 'state/selectors';
import type { Dispatch, User } from 'state/types';
import { CREATE_USER_PANEL_ID, CREATE_USER_FORM } from 'util/constants';
import { CreateUserForm } from './UserForm';
import { getRoles as getRolesAction } from 'state/commands/roleCommands';
import { NAME_PUBLISHER } from 'util/roleUtils';

type Props = {
  activePanelId: ?string,
  dispatch: Dispatch,
  getRolesAction: typeof getRolesAction,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
  newUser: ?User,
  valid: boolean,
};

const newUser: User = {
  addUserToAllCatalogs: false,
  fromLDAP: false,
  name: '',
  roleName: NAME_PUBLISHER,
};

class CreateUserDialog extends Component<Props> {
  isOkEnabled: Function;
  onSubmit: Function;

  constructor() {
    super();
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getRolesAction();
  }

  isOkEnabled() {
    return this.props.valid;
  }

  async onSubmit() {
    const { dispatch, hideDialogPanel } = this.props;
    //$FlowFixMe
    await dispatch(submit(CREATE_USER_FORM));
    hideDialogPanel();
  }

  render() {
    const {
      activePanelId,
      hideDialogPanel,
      intl: { formatMessage },
    } = this.props;
    return (
      <DialogPanel
        activePanelId={activePanelId}
        closeAfterSave={false}
        contentStyle={{ width: '650px', height: null }}
        customButtonText={formatMessage(localizedStrings.CREATE)}
        dialogFocusId="name-create"
        hideDialogPanel={hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onSave={this.onSubmit}
        panelId={CREATE_USER_PANEL_ID}
        panelTitle={formatMessage(localizedStrings.CREATE_USER)}
        showCancel
      >
        <CreateUserForm isCreate user={newUser} />
      </DialogPanel>
    );
  }
}

export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
    valid: isValid(CREATE_USER_FORM)(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm({
      getRolesAction,
      hideDialogPanel,
    })
)(injectIntl(CreateUserDialog));



// WEBPACK FOOTER //
// ./src/view/Pages/UsersPage/CreateUserDialog.js